import { apiUrl, getJson, postJson, putJson, patchJson, deleteJson } from './httpClient';

/**
 * Fetch all saved addresses for the authenticated customer.
 * @param {string} token
 * @returns {Promise<Array>}
 */
export async function fetchAddresses(token) {
  const res = await fetch(apiUrl('/addresses'), {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  const json = res.ok ? await res.json() : null;
  const list = json?.data?.addresses;
  return Array.isArray(list) ? list : [];
}

/**
 * Save a new address.
 * @param {{ address_line: string, label?: string, city?: string, state?: string, postal_code?: string, country?: string, latitude?: number, longitude?: number, is_default?: boolean }} payload
 * @param {string} token
 * @returns {Promise<object>}
 */
export async function createAddress(payload, token) {
  const json = await postJson('/addresses', {
    body: payload,
    token,
    globalLoading: false,
  });
  return json?.data?.address ?? {};
}

/**
 * Update an existing address.
 * @param {number} id
 * @param {object} payload
 * @param {string} token
 * @returns {Promise<object>}
 */
export async function updateAddress(id, payload, token) {
  const json = await putJson(`/addresses/${id}`, {
    body: payload,
    token,
    globalLoading: false,
  });
  return json?.data?.address ?? {};
}

/**
 * Delete an address.
 * @param {number} id
 * @param {string} token
 * @returns {Promise<void>}
 */
export async function deleteAddress(id, token) {
  await deleteJson(`/addresses/${id}`, { token, globalLoading: false });
}

/**
 * Set an address as the default.
 * @param {number} id
 * @param {string} token
 * @returns {Promise<object>}
 */
export async function setDefaultAddress(id, token) {
  const json = await patchJson(`/addresses/${id}/default`, {
    token,
    globalLoading: false,
  });
  return json?.data?.address ?? {};
}
